export enum IframeAPIEvent {
  READY = 'ready',
  PLAYBACK_UPDATE = 'playback_update',
}

export enum IframeCommands {
  PLAY = 'play',
  PAUSE = 'pause',
  TOGGLE_PLAY = 'toggle',
  SEEK = 'seek',
  LOAD_COMPLETE_ACK = 'load_complete_ack',
}
